export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 bg-background-50 border border-background-200/60 rounded-2xl p-8 md:p-12">
          <div className="flex-shrink-0">
            <div className="w-48 md:w-56 h-48 md:h-56 rounded-3xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20mobile%20phone%20mockup%20displaying%20entertainment%20news%20feed%2C%20mysterious%20crimson%20and%20black%20interface%20design%2C%20modern%20app%20screen%2C%20dramatic%20lighting%2C%20no%20text&width=500&height=500&seq=app-entry-91hl&orientation=squarish"
                alt="91黑料移动端入口"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              📱 随时随地看黑料
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg">
              91黑料移动端适配完美，无论您使用手机还是平板，都能获得流畅的浏览体验。本站支持移动浏览器直接访问，无需下载任何APP，输入网址即可畅享最新黑料视频。
              建议将本站添加到手机桌面，一键直达不迷路。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="px-5 py-2.5 bg-primary-500 text-white font-medium rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-smartphone-line mr-2"></i>
                手机浏览器访问
              </span>
              <span className="px-5 py-2.5 bg-background-100 text-foreground-700 font-medium rounded-full text-sm border border-background-300 whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors">
                <i className="ri-add-circle-line mr-2"></i>
                添加到桌面
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}